import { EllipsisVerticalIcon } from "lucide-react"
import { useEffect, useState } from "react"
import { Card, OverlayTrigger, Popover, Tooltip } from "react-bootstrap"
import { PortAlerts } from "../hooks/portAlertsService"
import { usePrevetTabStateContext } from "../hooks/prevetContext"
import { VesselStay } from "../hooks/useFetchVesselStays"
import { usePortAlerts } from "../hooks/usePortAlerts"

function PrevetPortAlertWidget({
  vesselStays,
}: {
  vesselStays: VesselStay[] | undefined
}) {
  const [chosenOrganization, setChosenOrganization] = useState("")
  const {
    portAlerts: paPortAlerts,
    chosenOrganization: paChosenOrganization,
    portAlertsVesselStays,
  } = usePortAlerts({ org_ids: [chosenOrganization] })

  useEffect(() => {
    if (paChosenOrganization) {
      setChosenOrganization(paChosenOrganization.id)
    }
  }, [paChosenOrganization, vesselStays, paPortAlerts])

  const { isPortAlertAdmin, setShowPortAlertModal } = usePrevetTabStateContext()

  const renderTooltipPortAlerts = () => {
    return (
      <Popover id="popover-basic">
        <Popover.Body>According to AIS - WOG. Data since 2021.</Popover.Body>
      </Popover>
    )
  }

  const renderTooltip = (props: any) => (
    <Tooltip id="edit-tooltip" {...props}>
      Edit port alerts
    </Tooltip>
  )

  const portAlertsVessel = portAlertsVesselStays(
    vesselStays ?? ([] as VesselStay[]),
    paPortAlerts ?? ([] as PortAlerts)
  )

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)

    // initial log

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function truncatePortName(
    portName: string,
    maxLength = 4,
    maxLengthBig = 50
  ) {
    // Truncate only if screen width is below 760px (mobile)
    if (screenWidth < 760) {
      return portName.length > maxLengthBig
        ? `${portName.slice(0, maxLengthBig)}...`
        : portName
    }
    // Don't truncate if screen width is 2140px or above, or below 1660px
    if (screenWidth >= 2140 || screenWidth < 1200) {
      return portName.length > maxLengthBig
        ? `${portName.slice(0, maxLengthBig)}...`
        : portName
    } else {
      return portName.length > maxLength
        ? `${portName.slice(0, maxLength)}...`
        : portName
    }
  }

  return (
    <>
      <Card className="PrevetContainer_PortAlerts">
        <Card.Body>
          <div className="w-100 d-flex justify-content-between">
            <div className="d-flex">
              <Card.Title>Port Alerts </Card.Title>
              <OverlayTrigger
                placement="top"
                overlay={renderTooltipPortAlerts()}
              >
                <i
                  className="ti-info-alt ms-1"
                  style={{ position: "relative", fontSize: "0.65rem" }}
                />
              </OverlayTrigger>
            </div>
            {isPortAlertAdmin && (
              <div className="d-flex gap-1">
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <EllipsisVerticalIcon
                    style={{ height: "20px", cursor: "pointer" }}
                    onClick={() => setShowPortAlertModal(true)}
                    className="hide-on-small-screen"
                  />
                </OverlayTrigger>
              </div>
            )}
          </div>
          <div className="portalerts-scroll-container">
            <table className="w-100">
              <tbody>
                {!portAlertsVessel || portAlertsVessel.length === 0 ? (
                  <tr>
                    <td>No port alerts found.</td>
                  </tr>
                ) : (
                  portAlertsVessel?.map((pa, i) => {
                    return (
                      <tr
                        key={i}
                        className={
                          pa.riskLevel === "red"
                            ? "text-danger"
                            : pa.riskLevel === "green"
                            ? "text-success"
                            : ""
                        }
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-${pa.port}_${pa.date_from}`}>
                              {
                                ((pa.port as string) +
                                  "- " +
                                  pa.date_from) as string
                              }
                            </Tooltip>
                          }
                        >
                          <td>{i + 1 + ". " + truncatePortName(pa.port)}</td>
                        </OverlayTrigger>
                        <td
                          className="hide-on-small-screen"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {pa.date_from}
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}

export default PrevetPortAlertWidget
